import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { fileUrl } from "../lib/apiClient";
import { Check, Sparkles, Palette } from "lucide-react";

export default function ConceptCompare({ open, onOpenChange, variations = [], concepts = [], selIdx = 0, onChoose, accent = "#F59E0B" }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0D1117] border-[#21262D] text-[#F0F6FC] max-w-5xl max-h-[92vh] overflow-y-auto" data-testid="concept-compare-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-heading text-xl">
            <Sparkles className="w-5 h-5 text-[#F59E0B]" /> Compare Concepts
          </DialogTitle>
          <p className="text-[#8B949E] text-sm">Three directions side by side — palette, materials and why each works. Pick one to present or build.</p>
        </DialogHeader>

        <div className="grid gap-3" style={{ gridTemplateColumns: `repeat(${Math.min(variations.length, 3)}, minmax(0, 1fr))` }}>
          {variations.map((p, i) => {
            const c = concepts[i] || {};
            const active = i === selIdx;
            return (
              <div key={p} className={`rounded-xl overflow-hidden border-2 bg-[#161B22] flex flex-col ${active ? "" : "border-[#21262D]"}`}
                style={{ borderColor: active ? accent : undefined }} data-testid={`compare-card-${i}`}>
                <div className="relative">
                  <img src={fileUrl(p)} alt={`concept ${i + 1}`} className="w-full h-44 object-cover" />
                  {c.bold && <span className="absolute top-2 left-2 text-[10px] px-1.5 py-0.5 rounded bg-[#F59E0B] text-[#0D1117] font-bold" data-testid={`compare-bold-${i}`}>BOLD · OUTSIDE THE BOX</span>}
                  {active && <span className="absolute top-2 right-2 w-6 h-6 rounded-full flex items-center justify-center text-[#0D1117]" style={{ background: accent }}><Check className="w-3.5 h-3.5" /></span>}
                </div>
                <div className="p-3 flex-1 flex flex-col gap-2">
                  <h4 className="font-heading font-semibold text-sm" data-testid={`compare-name-${i}`}>{c.name || `Concept ${i + 1}`}</h4>
                  {c.palette && (
                    <div className="text-xs text-[#8B949E] flex items-start gap-1.5"><Palette className="w-3.5 h-3.5 mt-0.5 shrink-0 text-[#38BDF8]" /><span><span className="text-[#6E7681]">Palette:</span> {c.palette}</span></div>
                  )}
                  {c.materials && (
                    <div className="text-xs text-[#8B949E]"><span className="text-[#6E7681]">Materials:</span> {c.materials}</div>
                  )}
                  {c.critique && (
                    <div className="text-xs text-[#C9D1D9] italic border-l-2 pl-2 mt-1" style={{ borderColor: accent }} data-testid={`compare-why-${i}`}>“{c.critique}”</div>
                  )}
                  <Button onClick={() => { onChoose?.(i); }} className="mt-auto w-full text-[#0D1117] font-semibold" style={{ background: accent }} data-testid={`compare-choose-${i}`}>
                    {active ? "Selected" : "Use this"}
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
